<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso a essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center mt-3" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="psp && !loading">
                        <div class="col-12 card-simple mb-3">
                            <div class="p-fluid p-formgrid grid">
                                <div class="col-12 md:col-3">
                                    <label class="label-superior">Código</label>
                                    <label class="label-inferior" id="empresa">
                                        {{ psp.id }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-3">
                                    <label class="label-superior">PSP</label>
                                    <label class="label-inferior" id="descricao">
                                        {{ psp.id }}
                                    </label>
                                </div>
                                <div class="col-12 md:col-3">
                                    <label class="label-superior">Tipo de chave Pix</label>
                                    <label class="label-inferior" id="descricao">
                                        {{ psp.tipoChavePix }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="w-full mb-5">
                            <p-table
                                #dt1
                                [value]="psp.metadados"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                styleClass="p-datatable-gridlines"
                                [paginator]="false"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Chave
                                            </div>
                                        </th>
                                        <th>
                                            <div
                                                class="flex justify-content-between align-items-center"
                                            >
                                                Valor
                                            </div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.chave }}</label>
                                        </td>

                                        <td>
                                            <label>{{ item.valor }}</label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/configuracao-pix"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
